import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catTiposServicio } from "../../Categorias y Estados/catTiposServicio";
import { estActivo } from "../../Categorias y Estados/estActivo";
import { Empresas } from "../../Empresas/Empresas";


const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente ID' }),
        c_empresa_id: new EntityColumn<string>({ name: 'c_empresa_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Empresa' }),
        vc_nombre_cliente: new EntityColumn<string>({ name: 'vc_nombre_cliente', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Cliente' }),
        vc_codigoexterno: new EntityColumn<string>({ name: 'vc_codigoexterno', type: 'varchar', length: 50, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Codigo externo' }),
        c_tiposervicio_id: new EntityColumn<string>({ name: 'c_tiposervicio_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tipo de servicio' }),
        c_activo_id: new EntityColumn<string>({ name: 'c_activo_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        clcf_brwStandard: { name: 'clcf_brwStandard', keyMappings: { c_cliente_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Empresas': {
            name: 'Empresas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Empresas(client, parentKeys)
        },

        'TiposServicio': {
            name: 'TiposServicio',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposServicio(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estActivo(client, parentKeys)
        }
    }
)

export class ClientesConfiguracionDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('ClientesConfiguracion');
    }
}